import Vue from 'vue';
import VueRouter from 'vue-router';

import AuthorizedLayout from '@/layouts/AuthorizedLayout';
import AuthLayout from '@/layouts/AuthLayout';
import BlankLayout from '@/layouts/BlankLayout';
import UnauthorizedLayout from '@/layouts/UnauthorizedLayout';

import store from '@/store';
import { cancelPendingRequests } from '@/services/_AxiosInstance';
import middleware from './middleware';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Mantraz',
    component: AuthorizedLayout,
    redirect: '/home',
    beforeEnter: middleware.isAuthenticated(store),
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/Index.vue'),
      },
      {
        path: 'voyage',
        name: 'Voyage',
        component: () => import('@/views/voyage/Voyage.vue'),
      },
      {
        path: 'voyage/:id',
        name: 'VoyageDetail',
        component: () => import('@/views/voyage/Detail.vue'),
      },
      {
        path: 'weather',
        name: 'Weather',
        component: () => import('@/views/home/Weather.vue'),
      },
      {
        path: 'dashboard/fms',
        name: 'FmsDashboard',
        component: () => import('@/views/dashboard/FmsDashboard.vue'),
      },
      {
        path: 'dashboard/bunker',
        name: 'BunkerDashboard',
        component: () => import('@/views/dashboard/BunkerDashboard.vue'),
      },
      {
        path: 'report/fms',
        name: 'FmsReport',
        component: () => import('@/views/report/FmsReport.vue'),
      },
      {
        path: 'report/datalog/fms',
        name: 'FmsDatalog',
        component: () => import('@/views/report/FmsReportDatalog.vue'),
      },
      {
        path: 'bunkering-log',
        name: 'BunkeringLog',
        component: () => import('@/views/bunkering_log/Index'),
      },
      {
        path: 'remain-on-board',
        name: 'RemainOnBoard',
        component: () => import('@/views/RemainOnBoard/Index.vue'),
      },
      {
        path: 'event/log',
        name: 'EventLog',
        component: () => import('@/views/event/EventLog.vue'),
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: () => import('@/views/Widgets'),
      },
      {
        path: 'asset/type/',
        name: 'AssetType',
        component: () => import('@/views/AssetType'),
      },
      {
        path: '401',
        name: 'Forbidden',
        component: () => import('@/views/Forbidden'),
      },
      {
        path: 'report',
        name: 'ReportWrapper',
        component: () => import('@/views/report/Wrapper.vue'),
      },
      {
        path: 'teltonika-map',
        name: 'TeltonikaMap',
        component: () => import('@/views/map/TeltonikaMap.vue'),
      },
      {
        path: 'report/custom-chart',
        name: 'ChartReport',
        component: () => import('@/views/report/ChartReport.vue'),
      },
      {
        path: 'report/operation-mode-summary',
        name: 'OperationModeSummary',
        component: () => import('@/views/report/OperationModeSummary.vue'),
      },
    ],
  },
  {
    path: '/preference',
    name: 'Preference',
    component: AuthLayout,
    beforeEnter: middleware.isAuthenticated(store),
    children: [
      {
        path: 'active-company',
        name: 'CompanyActiveSelection',
        component: () => import('@/views/auth/CompanyActiveSelection'),
      },
      {
        path: 'active-app',
        name: 'AppActiveSelection',
        component: () => import('@/views/auth/AppActiveSelection'),
      },
    ],
  },
  {
    path: '/master',
    name: 'Master',
    component: AuthorizedLayout,
    beforeEnter: middleware.isAuthenticated(store),
    children: [
      {
        path: 'configuration',
        name: 'MasterConfiguration',
        component: () => import('@/views/master/ConfigurationPage.vue'),
      },
      {
        path: 'config',
        name: 'Config',
        component: BlankLayout,
        children: [
          {
            path: 'rpm',
            name: 'MasterConfigRpm',
            component: () => import('@/views/master/config/rpm/Index'),
          },
          {
            path: 'ae',
            name: 'MasterConfigAe',
            component: () => import('@/views/master/config/ae/Index'),
          },
          {
            path: 'tank',
            name: 'MasterConfigTank',
            component: () => import('@/views/master/config/tank/Index'),
          },
          {
            path: 'event/:id?',
            name: 'MasterConfigEvent',
            component: () => import('@/views/master/config/event/Index'),
          },
        ],
      },
      {
        path: 'company',
        name: 'Company',
        component: () => import('@/views/master/company/Index.vue'),
      },
      {
        path: 'group',
        name: 'Group',
        component: () => import('@/views/master/group/Index'),
      },
      {
        path: 'asset',
        name: 'Asset',
        component: () => import('@/views/master/asset/Index.vue'),
      },
      {
        path: 'device',
        name: 'Device',
        component: () => import('@/views/master/device/Index.vue'),
      },
      {
        path: 'device/:id',
        name: 'AssetDevice',
        component: () => import('@/views/master/device/Index.vue'),
      },
      {
        path: 'device/detail/:id',
        name: 'DeviceDetail',
        component: () => import('@/views/master/device/Detail.vue'),
      },
      {
        path: 'event',
        name: 'MasterEvent',
        component: () => import('@/views/master/event/Index.vue'),
      },
      {
        path: 'asset/event/:id',
        name: 'AssetEvent',
        component: () => import('@/views/master/asset_event/Index.vue'),
      },
      {
        path: 'group/detail/:id',
        name: 'GroupDetail',
        component: () => import('@/views/master/group/Detail'),
      },
      {
        path: 'company/detail/:id',
        name: 'CompanyDetail',
        component: () => import('@/views/master/company/Detail.vue'),
      },
      {
        path: 'asset/detail/:id',
        name: 'AssetDetail',
        component: () => import('@/views/master/asset/Detail.vue'),
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/master/user/Index'),
      },
      {
        path: 'user/:id',
        name: 'UserDetail',
        component: () => import('@/views/master/user/Detail'),
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/master/role/Index'),
      },
      {
        path: 'role/:id',
        name: 'RoleDetail',
        component: () => import('@/views/master/role/Detail'),
      },
      {
        path: 'asset-type',
        name: 'MasterAssetType',
        component: () => import('@/views/master/asset_type/Index'),
      },
      {
        path: 'fuel-type',
        name: 'MasterFuelType',
        component: () => import('@/views/master/fuel_type/Index'),
      },
      {
        path: 'bunker-location',
        name: 'MasterBunkerLocation',
        component: () => import('@/views/master/bunker_location/Index'),
      },
      {
        path: 'permission',
        name: 'Permission',
        component: () => import('@/views/master/permission/Index'),
      },
      {
        path: 'sensor_type',
        name: 'MasterSensorType',
        component: () => import('@/views/master/sensor_type/Index'),
      },
      {
        path: 'sensor_category',
        name: 'MasterSensorCategory',
        component: () => import('@/views/master/sensor_category/Index'),
      },
      {
        path: 'tank',
        name: 'MasterTank',
        component: () => import('@/views/master/tank/Index'),
      },
      {
        path: 'tank/:id',
        name: 'MasterTankDetail',
        component: () => import('@/views/master/tank/Detail'),
      },
      {
        path: 'rpm-classification',
        name: 'RpmClassification',
        component: () => import('@/views/master/RpmClassification.vue'),
      },
      {
        path: 'rpm-classification/:id',
        name: 'RpmClassificationDetail',
        component: () => import('@/views/master/RpmClassificationDetail.vue'),
      },
      {
        path: 'landmarks',
        name: 'Landmarks',
        component: () => import('@/views/landmarks/Index.vue'),
      },

    ],
  },
  {
    path: '/auth',
    name: 'UnAuthorized',
    component: UnauthorizedLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/login/Index'),
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/auth/ForgotPassword'),
      },
      {
        path: 'update-password/:emailtoken/:token',
        name: 'UpdatePassword',
        component: () => import('@/views/auth/UpdatePassword'),
      },
      {
        path: 'export',
        name: 'Export',
        component: () => import('@/views/export/Index.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  cancelPendingRequests();
  next();
});

export default router;
